export default "__VITE_ASSET__BQCoKOb2__"